import React from "react";

const HeartIcon = ({ select, color , onClick }) => {
  return (
    <svg
    onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.39192 9.66527C1.49775 6.8736 2.54275 3.68277 5.47359 2.7386C7.01525 2.2411 8.71692 2.53443 9.99859 3.4986C11.2111 2.5611 12.9753 2.24443 14.5153 2.7386C17.4461 3.68277 18.4978 6.8736 17.6044 9.66527C16.2128 14.0903 9.99859 17.4986 9.99859 17.4986C9.99859 17.4986 3.83025 14.1419 2.39192 9.66527Z"
        stroke={color}
        fill={select && "red"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.332 5.58337C14.2237 5.87171 14.8537 6.66754 14.9295 7.60171"
        stroke={select ? "#fff" : color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default HeartIcon;
